// extracted by mini-css-extract-plugin
module.exports = {"container":"_3OPRcSq3qgmAUAoGPYxPPW","paragraph":"_1ie8NnUQ3DwaV45HKGeJ4u","empty":"MFtuP_IWEeVyeqaLfn_z5","spinner":"_21KIk7eg2Qc4K7Qgm69GPe","pagination":"rrWCg7_1DZKUBPrBdiihq"};